import { render, staticRenderFns } from "./HistoryCounter.vue?vue&type=template&id=1cb87043&scoped=true"
import script from "./HistoryCounter.vue?vue&type=script&setup=true&lang=ts"
export * from "./HistoryCounter.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HistoryCounter.vue?vue&type=style&index=0&id=1cb87043&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb87043",
  null
  
)

export default component.exports